import React from 'react';
import cn from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import VideoIcon from '@wix/da-ds/pkg/Icons/24x24/AddVideo';
import { isVideoDeviation, scaleToSize } from '../../../_helpers';
import MediaService from '../../../../utils/DeviationMediaService';
import BlurredBackground from '../BlurredBackground/BlurredBackground';

import paywallStyles from './Paywall.scss';

export interface Props {
  deviation: PapiDeviation;
  icon: React.ReactNode;
  iconClassName?: string;
  title: string;
  text: React.ReactNode;
  width?: number;
  height?: number;
  button?: React.ReactNode;
  belowButton?: React.ReactNode;
}

const PaywallLayout: React.FC<Props> = ({
  icon,
  iconClassName,
  title,
  text,
  button,
  deviation,
  width,
  height,
  belowButton,
}) => {
  const background = MediaService.getThumbSet(deviation).find(
    thumb => thumb.type === '400T'
  );
  const fullImage = MediaService.getFullviewForSize(deviation, width, height);
  const childBoxSize = fullImage
    ? scaleToSize(fullImage, { width, height })
    : { width, height };

  const isVideo = isVideoDeviation(deviation);

  return (
    <div
      style={{
        width,
        height,
      }}
      className={cn(paywallStyles['root'], paywallStyles['seller-discounts'])}
    >
      <div
        style={childBoxSize}
        className={paywallStyles['blocked-placeholder']}
      >
        {/* blur is done on backend for premium folders */}
        {background && <BlurredBackground imageUrl={background.src} />}
        <div className={paywallStyles['blocked-wrap']}>
          <div className={cn(paywallStyles['blocked-icon'], iconClassName)}>
            {icon}
          </div>
          {title && (
            <div className={paywallStyles['blocked-title']}>
              {isVideo && (
                <VideoIcon className={paywallStyles['blocked-title-icon']} />
              )}
              <span>{title}</span>
            </div>
          )}
          {text && <div className={paywallStyles['blocked-text']}>{text}</div>}
          {button}
          {belowButton && (
            <div className={paywallStyles['below-button']}>{belowButton}</div>
          )}
        </div>
      </div>
    </div>
  );
};
PaywallLayout.displayName = 'PaywallLayout';

export default PaywallLayout;
